import React from 'react';
import { useUnistyles } from 'react-native-unistyles';

const DividerBlock = ({ block, isSelected, onSelect }) => {
    const { theme: { colors } } = useUnistyles();
    const { content, styles: blockStyles } = block;

    const padding = `${blockStyles.paddingTop ?? 10}px ${blockStyles.paddingRight ?? 20}px ${blockStyles.paddingBottom ?? 10}px ${blockStyles.paddingLeft ?? 20}px`;

    return (
        <div
            onClick={(e) => { e.stopPropagation(); onSelect(block.id); }}
            style={{
                padding,
                backgroundColor: blockStyles.backgroundColor || 'transparent',
                outline: isSelected ? `2px solid ${colors.primary}` : '2px solid transparent',
                outlineOffset: '-2px',
                cursor: 'pointer',
            }}
        >
            <hr
                style={{
                    borderTop: `${content.thickness || 1}px solid ${content.color || '#e5e7eb'}`,
                    borderBottom: 'none',
                    borderLeft: 'none',
                    borderRight: 'none',
                    width: content.width || '100%',
                    margin: '0 auto',
                }}
            />
        </div>
    );
};

export default DividerBlock;
